<template>
  <div class="news" id="directory">
    <!-- 头部导航组件 -->
    <header-cmp></header-cmp>
    <menu-cmp></menu-cmp>

    <section>
      <div class="news-center">
        <div class="content">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item><a href="/">名录</a></el-breadcrumb-item>
        </el-breadcrumb>          
          <div  class="tab-panel athletics">
            <div class="field box-con" >
              <div class="title">
                <el-col :span="20">
                  <i></i><h3>名录</h3>
                </el-col>
              </div>
              <div class="content">
                <ul>
                  <li v-for="(item, index) in tg.right" :key="index">
                  <el-col :span="20"><h3>{{item.name}}</h3></el-col>
                  <el-col :span="4" style="text-align: right">
                    <img :src="item.img" alt="">
                  </el-col>
                  </li>
                </ul> 
              </div>
            </div>        
          </div>
        </div>
      </div>
    </section>
    <footer-cmp></footer-cmp>
  </div>
</template>

<script>
  import headerCmp from "../components/common/header.vue"
  import menuCmp from "../components/common/navMenu.vue"
  import footerCmp from "../components/common/footer.vue"
  export default{ 
    data(){ 
      return{ 
        sports:[
          {id:1, name:'短距离跑',icon:'http://zhongtian.ezhangxiu.cn/attached/user/company/202204/d6/d6d5ff305f58d421cbf2c97b20fca843.jpg' },
          {id:1, name:'接力跑',icon:'http://zhongtian.ezhangxiu.cn/attached/user/company/202204/d6/d6d5ff305f58d421cbf2c97b20fca843.jpg' },
          {id:1, name:'中长跑',icon:'http://zhongtian.ezhangxiu.cn/attached/user/company/202204/d6/d6d5ff305f58d421cbf2c97b20fca843.jpg' },
          {id:1, name:'短距离跑',icon:'http://zhongtian.ezhangxiu.cn/attached/user/company/202204/d6/d6d5ff305f58d421cbf2c97b20fca843.jpg' },
          {id:1, name:'3000米障碍跑',icon:'http://zhongtian.ezhangxiu.cn/attached/user/company/202204/d6/d6d5ff305f58d421cbf2c97b20fca843.jpg' },
          {id:1, name:'短距离跑',icon:'http://zhongtian.ezhangxiu.cn/attached/user/company/202204/d6/d6d5ff305f58d421cbf2c97b20fca843.jpg' },
          {id:1, name:'短距离跑',icon:'http://zhongtian.ezhangxiu.cn/attached/user/company/202204/d6/d6d5ff305f58d421cbf2c97b20fca843.jpg' },
          {id:1, name:'短距离跑',icon:'http://zhongtian.ezhangxiu.cn/attached/user/company/202204/d6/d6d5ff305f58d421cbf2c97b20fca843.jpg' },
          {id:1, name:'短距离跑',icon:'http://zhongtian.ezhangxiu.cn/attached/user/company/202204/d6/d6d5ff305f58d421cbf2c97b20fca843.jpg' },
          {id:1, name:'短距离跑',icon:'http://zhongtian.ezhangxiu.cn/attached/user/company/202204/d6/d6d5ff305f58d421cbf2c97b20fca843.jpg' },
          {id:1, name:'短距离跑',icon:'http://zhongtian.ezhangxiu.cn/attached/user/company/202204/d6/d6d5ff305f58d421cbf2c97b20fca843.jpg' },
          {id:1, name:'短距离跑',icon:'http://zhongtian.ezhangxiu.cn/attached/user/company/202204/d6/d6d5ff305f58d421cbf2c97b20fca843.jpg' },
          {id:1, name:'短距离跑',icon:'http://zhongtian.ezhangxiu.cn/attached/user/company/202204/d6/d6d5ff305f58d421cbf2c97b20fca843.jpg' },
          {id:1, name:'短距离跑',icon:'http://zhongtian.ezhangxiu.cn/attached/user/company/202204/d6/d6d5ff305f58d421cbf2c97b20fca843.jpg' },
        ],
        tabs:[
          { id: 1, name: '新闻通告'},
          { id: 2, name: '田径文化'},
          { id: 3, name: '名录公示'}
        ],
        activeName: '',
        isActive: null,
        news:[
          { id: 1, name: '新闻消息1', desc: 'Tabs 组件提供了选项卡功能，默认选中第一个标签页，你也可以通过 value 属性来指定当前选中的标签页。', dateTime: '2020-01-01', img: 'http://zhongtian.ezhangxiu.cn/attached/user/company/202204/d6/d6d5ff305f58d421cbf2c97b20fca843.jpg'},
          { id: 1, name: '新闻消息1', desc: 'Tabs 组件提供了选项卡功能，默认选中第一个标签页，你也可以通过 value 属性来指定当前选中的标签页。', dateTime: '2020-01-01', img: 'http://zhongtian.ezhangxiu.cn/attached/user/company/202204/d6/d6d5ff305f58d421cbf2c97b20fca843.jpg'},
          { id: 1, name: '新闻消息1', desc: 'Tabs 组件提供了选项卡功能，默认选中第一个标签页，你也可以通过 value 属性来指定当前选中的标签页。', dateTime: '2020-01-01', img: 'http://zhongtian.ezhangxiu.cn/attached/user/company/202204/d6/d6d5ff305f58d421cbf2c97b20fca843.jpg'},
          { id: 1, name: '新闻消息1', desc: 'Tabs 组件提供了选项卡功能，默认选中第一个标签页，你也可以通过 value 属性来指定当前选中的标签页。', dateTime: '2020-01-01', img: 'http://zhongtian.ezhangxiu.cn/attached/user/company/202204/d6/d6d5ff305f58d421cbf2c97b20fca843.jpg'},
          { id: 1, name: '新闻消息1', desc: 'Tabs 组件提供了选项卡功能，默认选中第一个标签页，你也可以通过 value 属性来指定当前选中的标签页。', dateTime: '2020-01-01', img: 'http://zhongtian.ezhangxiu.cn/attached/user/company/202204/d6/d6d5ff305f58d421cbf2c97b20fca843.jpg'},
        ],
        directories:[
          { id: 1, name: '新闻消息1新闻消息1新闻消息1新闻消息1新闻消息1', desc: 'Tabs 组件提供了选项卡功能，默认选中第一个标签页，你也可以通过 value 属性来指定当前选中的标签页。', dateTime: '2020-01-01', img: 'http://zhongtian.ezhangxiu.cn/attached/user/company/202204/d6/d6d5ff305f58d421cbf2c97b20fca843.jpg'},
          { id: 1, name: '新闻消息1新闻消息1新闻消息1新闻消息1新闻消息1', desc: 'Tabs 组件提供了选项卡功能，默认选中第一个标签页，你也可以通过 value 属性来指定当前选中的标签页。', dateTime: '2020-01-01', img: 'http://zhongtian.ezhangxiu.cn/attached/user/company/202204/d6/d6d5ff305f58d421cbf2c97b20fca843.jpg'},
          { id: 1, name: '新闻消息1新闻消息1新闻消息1新闻消息1新闻消息1', desc: 'Tabs 组件提供了选项卡功能，默认选中第一个标签页，你也可以通过 value 属性来指定当前选中的标签页。', dateTime: '2020-01-01', img: 'http://zhongtian.ezhangxiu.cn/attached/user/company/202204/d6/d6d5ff305f58d421cbf2c97b20fca843.jpg'},
          { id: 1, name: '新闻消息1新闻消息1新闻消息1新闻消息1新闻消息1', desc: 'Tabs 组件提供了选项卡功能，默认选中第一个标签页，你也可以通过 value 属性来指定当前选中的标签页。', dateTime: '2020-01-01', img: 'http://zhongtian.ezhangxiu.cn/attached/user/company/202204/d6/d6d5ff305f58d421cbf2c97b20fca843.jpg'},
          { id: 1, name: '新闻消息1新闻消息1新闻消息1新闻消息1', desc: 'Tabs 组件提供了选项卡功能，默认选中第一个标签页，你也可以通过 value 属性来指定当前选中的标签页。', dateTime: '2020-01-01', img: 'http://zhongtian.ezhangxiu.cn/attached/user/company/202204/d6/d6d5ff305f58d421cbf2c97b20fca843.jpg'},          
        ],
        tg:{ 
          left:[
            { id: 1, name: '新闻消息1新闻消息1新闻消息1新闻消息1', desc: 'Tabs 组件提供了选项卡功能，默认选中第一个标签页，你也可以通过 value 属性来指定当前选中的标签页。', dateTime: '2020-01-01', img: 'http://zhongtian.ezhangxiu.cn/attached/user/company/202204/d6/d6d5ff305f58d421cbf2c97b20fca843.jpg'},
            { id: 1, name: '新闻消息1新闻消息1新闻消息1新闻消息1', desc: 'Tabs 组件提供了选项卡功能，默认选中第一个标签页，你也可以通过 value 属性来指定当前选中的标签页。', dateTime: '2020-01-01', img: 'http://zhongtian.ezhangxiu.cn/attached/user/company/202204/d6/d6d5ff305f58d421cbf2c97b20fca843.jpg'},
            { id: 1, name: '新闻消息1新闻消息1新闻消息1新闻消息1', desc: 'Tabs 组件提供了选项卡功能，默认选中第一个标签页，你也可以通过 value 属性来指定当前选中的标签页。', dateTime: '2020-01-01', img: 'http://zhongtian.ezhangxiu.cn/attached/user/company/202204/d6/d6d5ff305f58d421cbf2c97b20fca843.jpg'},
          ],
          right: [
            { id: 1, name: '新闻消息1新闻消息1新闻消息1新闻消息1', desc: 'Tabs 组件提供了选项卡功能，默认选中第一个标签页，你也可以通过 value 属性来指定当前选中的标签页。', dateTime: '2020-01-01', img: 'http://zhongtian.ezhangxiu.cn/attached/user/company/202204/d6/d6d5ff305f58d421cbf2c97b20fca843.jpg'},
            { id: 1, name: '新闻消息1新闻消息1新闻消息1新闻消息1', desc: 'Tabs 组件提供了选项卡功能，默认选中第一个标签页，你也可以通过 value 属性来指定当前选中的标签页。', dateTime: '2020-01-01', img: 'http://zhongtian.ezhangxiu.cn/attached/user/company/202204/d6/d6d5ff305f58d421cbf2c97b20fca843.jpg'},
            { id: 1, name: '新闻消息1新闻消息1新闻消息1新闻消息1', desc: 'Tabs 组件提供了选项卡功能，默认选中第一个标签页，你也可以通过 value 属性来指定当前选中的标签页。', dateTime: '2020-01-01', img: 'http://zhongtian.ezhangxiu.cn/attached/user/company/202204/d6/d6d5ff305f58d421cbf2c97b20fca843.jpg'},
            { id: 1, name: '新闻消息1新闻消息1新闻消息1新闻消息1', desc: 'Tabs 组件提供了选项卡功能，默认选中第一个标签页，你也可以通过 value 属性来指定当前选中的标签页。', dateTime: '2020-01-01', img: 'http://zhongtian.ezhangxiu.cn/attached/user/company/202204/d6/d6d5ff305f58d421cbf2c97b20fca843.jpg'},
          ],
          center: [
            { id: 1, name: '新闻消息1新闻消息1新闻消息1新闻消息1', desc: 'Tabs 组件提供了选项卡功能，默认选中第一个标签页，你也可以通过 value 属性来指定当前选中的标签页。', dateTime: '2020-01-01', img: 'http://zhongtian.ezhangxiu.cn/attached/user/company/202204/d6/d6d5ff305f58d421cbf2c97b20fca843.jpg'},
          ]
        }
      }
    },
    components:{ 
      headerCmp,
      menuCmp,
      footerCmp
    },
    methods:{ 
      handleClick(index,data){ 
        this.isActive = index;
        this.activeName = data.name;
        console.log("点击：", data)
      }
    },
    mounted(){ }
  }
</script>

<style lang="scss" scoped>
@import "../assets/style/media.scss"
</style>